import { ToastProvider } from "./components/toast/ToastProvider";
import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import "./index.css";
import { App } from "./App";
import { setUnauthorizedHandler } from "./lib/api";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Plant-floor agent — UI is a control panel, not a high-throughput app.
      // Refetch on focus is more annoying than helpful here.
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 30_000,
    },
  },
});

// Global 401 handler — when any API call discovers the session has expired,
// nuke the meQuery cache so the App re-renders to the LoginPage. Registered
// before <App /> mounts so the very first call is covered.
setUnauthorizedHandler(() => {
  queryClient.removeQueries({ queryKey: ["me"] });
  queryClient.invalidateQueries({ queryKey: ["me"] });
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ToastProvider>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </ToastProvider>
  </React.StrictMode>,
);
